import { Link, Text } from '@change/ds-core-ui';
import { ChevronLeftIcon, ChevronRightIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core/react/i18n';

import { useSiblingsNavigation } from './hooks/useSiblingsNavigation';

export function SiblingsNavigation({ className }: { className?: string }) {
	const {
		data: { previous, next },
	} = useSiblingsNavigation();

	if (!previous && !next) return null;

	return (
		<div className={className}>
			<div className="flex justify-between gap-4">
				<div className="max-w-80">
					{previous && (
						<Link data-qa="link-navigation-previous" href={previous.url} variant="secondary">
							<div className="flex">
								<ChevronLeftIcon className="mr-2" size="x-large" />
								<div>
									<Text as="div" fontWeight="bold">
										<Translate value="fe.components.paging.previous" />
									</Text>
									<Text className="text-typography-weak break-normal" as="div">
										{previous.title}
									</Text>
								</div>
							</div>
						</Link>
					)}
				</div>
				<div className="max-w-80">
					{next && (
						<Link data-qa="link-navigation-next" href={next.url} variant="secondary">
							<div className="flex text-right">
								<div>
									<Text as="div" fontWeight="bold">
										<Translate value="fe.components.paging.next" />
									</Text>
									<Text className="text-typography-weak break-normal" as="div">
										{next.title}
									</Text>
								</div>
								<ChevronRightIcon className="mr-2" size="x-large" />
							</div>
						</Link>
					)}
				</div>
			</div>
		</div>
	);
}
